export enum FlexType {
	FlexMicroForm = 1,
	FlexApi,
}
